/**
 * Moves the header down the initial height of the .site-notice if it's present on load
 **/
function initializeUIPositions() {
  // const noticeHeight = Math.round($('.site-notice').height());
  // const stickyMenu = $('header');
  // const initialScrollTop = $(window).scrollTop();

  // // if initialScrollTop is further than the noticeHeight, adjust the top position of the sticky menu
  // if (initialScrollTop > noticeHeight) {
  //   stickyMenu.css('top', `${noticeHeight}px`);
  // }

  // const alertsWrapper = $('.menu__alertswrapper');

  // // if alertsWrapper is present, adjust the top position of the sticky menu
  // alertsWrapper.css('margin-top', `${noticeHeight}px`);

}


/**
 * Animates the notice away and triggers ajax function to set session state to notice closed
 **/
function CloseNotice() {
  if ($('.site-notice').length > 0) {
    var notice = $('.site-notice');
    const stickyMenu = $('header');
    var absoluteBase = notice.attr('data-absolutebase');
    var currentLink = notice.attr('data-currentlink');

    if (currentLink == absoluteBase) { // if home page append /home/
      currentLink = absoluteBase + 'home/';
    }

    var allowedAction = 'setNoticeStateToClosed'; // function on PageController

    // on click of the close button
    notice.find('.close').on('click', function (evt) {

      // animate the notice away
      notice.slideUp();

      // fire ajax to call allowedAction to set session state to notice closed
      $.ajax({
        url: currentLink.replace(/\/?$/, "/") + allowedAction,
        type: 'POST',
        data: {},
        response: function (response) {
          console.log(response);
        }
      });

      stickyMenu.css('top', '0');
    });

  }
}


/**
 * Reposition the sticky menu menu to compensate for the height of the notice
 **/
function RePositionStickyMenuIfNotice() {
  if ($('.site-notice').length > 0) {
    var noticeHeight = Math.round($('.site-notice').height());
    var stickyMenu = $('header');
    var stickyMenuBackdrop = $('.header-backdrop');
    var pageTop; 

    if ($('.menu__alertswrapper').length > 0) {
      pageTop = $('.menu__alertswrapper');
    } else if ($('.banner').length > 0) {
      pageTop = $('.banner');
    } else {
      pageTop = $('.page__body');
    }

    var stickyMenuOriginalTopPosition = parseInt($(stickyMenu).css('top'));
    var stickyMenuNewTopPostition = stickyMenuOriginalTopPosition + noticeHeight;

    // on load - if clear of notice height adopt normal position, otherwise position to add on the height of the notice
    if ($(window).scrollTop() < noticeHeight) {
      stickyMenu.css('top', stickyMenuNewTopPostition);
      stickyMenuBackdrop.css('top', stickyMenuNewTopPostition);
      pageTop.css('margin-top', stickyMenuNewTopPostition);
      // globalAlertbackdrop.css('margin-top', stickyMenuNewTopPostition);
    } else {
      stickyMenu.css('top', stickyMenuOriginalTopPosition);
      stickyMenuBackdrop.css('top', stickyMenuOriginalTopPosition);
      pageTop.css('margin-top', 0);
    }

    // on scroll - if clear of notice height adopt normal position, otherwise position to add on the height of the notice
    // $(window).scroll(function () {
    //   if (!$('.site-notice').hasClass('hidden')) {
    //     if ($(window).scrollTop() < noticeHeight) {
    //       console.log('scroll position less than notice Height, check diff')
    //       stickyMenu.css('top', stickyMenuNewTopPostition - $(window).scrollTop());
    //       stickyMenuBackdrop.css('top', stickyMenuNewTopPostition - $(window).scrollTop());
    //       pageTop.css('margin-top', stickyMenuNewTopPostition );
    //     } else {
    //       console.log('scroll position greater than notice Height, go to originals')
    //       stickyMenu.css('top', stickyMenuOriginalTopPosition);
    //       stickyMenuBackdrop.css('top', stickyMenuOriginalTopPosition);
    //       pageTop.css('margin-top', 0);
    //     }
    //   }
    // });

    // reposition the mobile menu menu to compensate for the height of the notice
    var mobileMenu = $('.menu__panel');
    mobileMenuOriginalMaxHeight = mobileMenu.css('max-height');
    mobileMenuNewMaxHeight = parseInt(mobileMenuOriginalMaxHeight) - noticeHeight;
    mobileMenu.css('max-height', mobileMenuNewMaxHeight);

    // change the sticky menu and mobile menu to its original position on close of notice
    $('.site-notice').find('.close').on('click', function (evt) {
      stickyMenu.css('transition', 'all .5s');
      stickyMenuBackdrop.css('transition', 'all .5s');
      pageTop.css('transition', 'all .5s');

      stickyMenu.css('top', stickyMenuOriginalTopPosition);
      stickyMenuBackdrop.css('top', stickyMenuOriginalTopPosition);
      stickyMenuNewTopPostition = stickyMenuOriginalTopPosition;
      pageTop.css('margin-top', 0);
      mobileMenu.css('max-height', mobileMenuOriginalMaxHeight);
      $('.site-notice').addClass('hidden');

      setTimeout(function () {
        stickyMenu.css('transition', 'none');
        stickyMenuBackdrop.css('transition', 'none');
        pageTop.css('transition', 'none');
      }, 500);
    });
  }
}


$(document).ready(function () {
  initializeUIPositions();
  CloseNotice();
  RePositionStickyMenuIfNotice();
});